/**
 * The Divergent logo assembling itself, shown while a page's code loads.
 *
 * The markup is the same as the preloader inside #root in index.html, and both
 * are styled by public/loader.css. Change one, change the other;
 * `Loader.test.tsx` holds them together.
 */
export function Loader({ screen = false }: { screen?: boolean }) {
  return (
    <div
      className={`dn-loader ${screen ? 'dn-loader--screen' : 'dn-loader--inline'}`}
      role="status"
      aria-label="Loading"
    >
      <svg className="dn-loader__mark" viewBox="0 0 110 100" aria-hidden="true">
        <path className="dn-loader__t dn-loader__navy dn-loader__d3" d="M27 45 L53 19 H70 L77 12" />
        <path className="dn-loader__t dn-loader__navy dn-loader__d3" d="M27 55 L53 81 H70 L77 88" />
        <path className="dn-loader__t dn-loader__blue dn-loader__d2" d="M31 47 L46 33 H78" />
        <path className="dn-loader__t dn-loader__blue dn-loader__d2" d="M31 53 L46 67 H78" />
        <path className="dn-loader__t dn-loader__navy dn-loader__d1" d="M28 50 H92" />
        <circle className="dn-loader__n dn-loader__navy dn-loader__d3" cx="81" cy="8" r="6" />
        <circle className="dn-loader__n dn-loader__navy dn-loader__d3" cx="81" cy="92" r="6" />
        <circle className="dn-loader__n dn-loader__blue dn-loader__d2" cx="84" cy="33" r="6" />
        <circle className="dn-loader__n dn-loader__blue dn-loader__d2" cx="84" cy="67" r="6" />
        <circle className="dn-loader__n dn-loader__navy dn-loader__d1" cx="98" cy="50" r="6" />
        <path className="dn-loader__core" d="M14 37 L25.3 43.5 V56.5 L14 63 L2.7 56.5 V43.5 Z" />
      </svg>
      <span className="dn-loader__name">Divergent Networks</span>
    </div>
  );
}
